import React, { memo, useContext } from 'react';
import { useDispatch } from 'react-redux';

import ActionButton from './ActionButton';
import { deleteModuleOrModifier } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import TrashIcon from '@ad-scripts/presentation/components/common/icons/trash';
import { SidekickThreadEditorContext } from 'src/presentation/components/pages/sidekick/threads/SidekickThreadEditorContext';

type DeleteButtonProps = {
  anonModifierId?: string;
  disabled?: boolean;
  modifierId?: string;
  moduleId: string;
  title: string;
};

const DeleteButton = ({ disabled, moduleId, modifierId, anonModifierId, title }: DeleteButtonProps) => {
  const { deleteConfirmationModalRef } = useContext(SidekickThreadEditorContext);

  const dispatch = useDispatch();

  const handleSubmit = e => {
    e.stopPropagation();
    dispatch(deleteModuleOrModifier({ moduleId, modifierId, anonModifierId, history }));
  };

  const handleDeleteButtonClick = e => {
    e.stopPropagation();
    deleteConfirmationModalRef.current?.show({ title, subscribe: () => handleSubmit(e) });
  };

  return (
    <>
      <ActionButton onClick={handleDeleteButtonClick} title="Delete" disabled={disabled}>
        <TrashIcon width="16" alt="delete" />
      </ActionButton>
    </>
  );
};

export default memo(DeleteButton);
